import { Api } from "../config/request";

export default {
  getDriverServices() {
    return Api.get("/drivers/driver-services");
  },
  exclusiveDriverService() {
    return Api.get("/drivers/exclusive-driver-services");
  },
};
